import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import useForm from 'hooks/useForm';

import { TextField } from '@material-ui/core';
import PasswordField from 'components/core/PasswordField';

const useStyles = makeStyles(theme => ({
    subtitle: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
            display: 'block',
            paddingLeft: theme.spacing(1/4)
        // },
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    formTitle: {
        paddingBottom: theme.spacing(5)
    },
    textField: {
        width: theme.spacing(41)
    }
}))

const InputLabelProps = {
    required: false //Hide asterix on required field
}

export default function ChangePasswordForm({ record, isSubmitting, onSubmit, onError }) {
    const classes = useStyles()
    const ref = useRef()
    const validations = { currentPassword: ['required'], newPassword: ['required'], confirmPassword: ['required']  }
    const [state, errors, handleChange, handleBlur, handleSubmit] = useForm(callback, validations, record)

    function callback() {
		if (state.newPassword === state.confirmPassword) {
			errors['confirmPassword'] = null
			if (onSubmit) onSubmit(state, ref)
		} else {
			errors['confirmPassword'] = 'Passwords don\'t match'
		}
    }

    useEffect(() => {
        (Object.keys(errors).length > 0 && onError && onError(errors))
    }, [errors])

    useEffect(() => {
        (isSubmitting === true && handleSubmit())
    }, [isSubmitting])

    return (
        <form ref={ref} className={classes.form} autoComplete="off" onSubmit={handleSubmit} noValidate>
			<PasswordField
				id="currentPassword"
				label="Current Password"
				className={classes.textField}
				onChange={handleChange}
				autoComplete="current-password"
				required={true}
				error={!!errors['currentPassword']}
                helperText={!!errors['currentPassword'] && errors['currentPassword']}
			/>
			<PasswordField
				id="newPassword"
				label="New Password"
				className={classes.textField}
				onChange={handleChange}
				autoComplete="off"
				required={true}
				error={!!errors['newPassword']}
                helperText={!!errors['newPassword'] && errors['newPassword']}
			/>
			<PasswordField
				id="confirmPassword"
				label="Confirm Password"
				className={classes.textField}
				onChange={handleChange}
				autoComplete="off"
				required={true}
				error={!!errors['confirmPassword']}
                helperText={!!errors['confirmPassword'] && errors['confirmPassword']}
			/>
        </form>
    )
}